import React from 'react';
import { Button, Modal } from '../../../../common/_custom';
import Dropdown from '../../../../common/_custom/Dropdown';
import styles from './DataRoomModals.module.scss';
import useDataRoomModalsLogic from './useDataRoomModalsLogic';
import { FolderInfo } from '../../useCallApiToFetchFileData';
import { Mixpanel } from '../../../../utils/mixpanel';
import { getSubdomain } from '../../../../utils/utils';
import { useAppSelector } from '../../../../app/hooks';
import { AICA_DATAROOM_FILE_SAVE_MOVED } from '../../../../utils/constants/mixpanelEvents/investorEvents';

type DataRoomsModalProps = {
    setIsFetchingData: React.Dispatch<React.SetStateAction<boolean>>;
    fetchFiles: Function;
    showDataRoomModal: {
        showModal: boolean;
        docId?: number;
        currentDocType?: string;
        selectedDocIds?: number[];
        onMoveSuccess?: () => void;
    };
    setShowDataRoomModal: (value: {
        showModal: boolean;
        docId?: number;
        currentDocType?: string;
        selectedDocIds?: number[];
        onMoveSuccess?: () => void;
    }) => void;
    dataTypesSubFolderList: Record<string, FolderInfo>;
    modalHeaderTitle: string;
    onCloseClick: () => void;
};

const DataRoomModals: React.FC<DataRoomsModalProps> = ({
    setIsFetchingData,
    fetchFiles,
    showDataRoomModal,
    setShowDataRoomModal,
    dataTypesSubFolderList,
    modalHeaderTitle,
    onCloseClick,
}) => {
    const user = useAppSelector((state) => state.user.userData);
    const selectedCompany = useAppSelector((state) => state.investor.selectedCompany);
    const { selectedOption, setSelectedOption, handleMetaDataUpdate } = useDataRoomModalsLogic({
        setIsFetchingData,
        docId: showDataRoomModal.docId,
        fetchFiles: fetchFiles,
        currentDocType: showDataRoomModal?.currentDocType,
        dataTypesSubFolderList,
        selectedDocIds: showDataRoomModal?.selectedDocIds,
        onMoveSuccess: showDataRoomModal?.onMoveSuccess,
    });

    return (
        <Modal
            open={showDataRoomModal.showModal}
            onClose={onCloseClick}
            style={{
                width: '28.125rem',
                height: '14.4375rem',
                margin: '0',
                padding: '1.5rem',
                paddingBottom: '0rem',
            }}
            closeIconStyle={{
                marginRight: '0.875rem',
                marginTop: '1rem',
                width: '0.875rem',
                height: '0.875rem',
            }}
        >
            <div className={styles.ModalContent}>
                <h3 className={styles.Heading} style={{ marginTop: '0rem' }}>
                    {modalHeaderTitle}
                </h3>
                <Dropdown
                    customClass={true}
                    enableSearch={true}
                    hideOtherOptionWhenNoMatch={true}
                    optionsList={
                        dataTypesSubFolderList
                            ? Object.entries(dataTypesSubFolderList).map(([key, opt]) => ({
                                  id: opt.fullPath,
                                  label: opt?.nestedPath || opt?.fullPath,
                              }))
                            : []
                    }
                    selectedOption={{
                        id: selectedOption?.selected,
                        label: selectedOption?.selected,
                    }}
                    itemClickHandler={(value) => {
                        setSelectedOption({
                            selected: value?.label ?? '',
                            contextId: value?.id ? String(value?.id) : '',
                        });
                    }}
                    placeholder="Select Folder"
                    label="Select Folder"
                    style={{ width: '100%', height: '2.75rem' }}
                />
                <div className={styles.CTAs}>
                    <Button
                        text="Cancel"
                        variant="secondary"
                        onClick={onCloseClick}
                        style={{ width: '50%', marginTop: '0', marginBottom: '0rem', height: '2.5rem' }}
                    />
                    <Button
                        text="Save"
                        onClick={async () => {
                            await handleMetaDataUpdate();
                            setShowDataRoomModal({
                                showModal: false,
                            });

                            Mixpanel.track(AICA_DATAROOM_FILE_SAVE_MOVED, {
                                userRole: user?.accountType,
                                pnoPlatform: getSubdomain(),
                                userId: user?.userId,
                                currentUrl: window.location.href,
                                organizationId: selectedCompany?.assesseeOrgId,
                                folderType: selectedOption?.selected,
                            });
                        }}
                        variant="primary"
                        style={{ width: '50%', marginTop: '0', marginBottom: '0rem', height: '2.5rem' }}
                        disabled={!selectedOption?.selected}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default DataRoomModals;
